import {ErrorHandler, Injectable} from '@angular/core';
import {confirm} from 'devextreme/ui/dialog';
import {throwError} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalInterceptorService implements ErrorHandler {
  public handleError(error: any): void {
    if (error.code === 'NS_ERROR_STORAGE_IOERR' || error.name === 'NS_ERROR_STORAGE_IOERR') {
      confirm('A known error occurred, do you want to see how to fix it?', 'Error')
        .then(response => {
          if (!response) {
            return throwError(error);
          }
          window.location.href = 'https://ocllis.atlassian.net/wiki/x/AoDtD';
          return;
        });
    }
    if (/Loading chunk [\d]+ failed/.test(error.message) || /Unexpected token '<'/.test(error.message)) {
      location.reload();
      return;
    }
    throwError(error);
  }
}
